var PvStrategyService_1;
import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { AflaModuleStrategyService, SearchContainerHeight } from "./afla-module-strategy.service";
import _ from "underscore";
import { SaShortDatePipe } from "../../pipes/sa-short-date/sa-short-date.pipe";
import { ModuleConfig } from "../../models/module-config.model";
import { SharedConstants } from "../../constants/shared.constants";
import { ViewApplicationDetailsPvComponent } from "../../../application/view-application/modules/pv/view-application-details-pv/view-application-details-pv.component";
import { CreateApplicationDetailsPvComponent } from "../../../application/create-application/modules/pv/create-application-details-pv/create-application-details-pv.component";
import { SearchAssignedToComponent } from "../../../tabs/applications/application-search/search-assigned-to/search-assigned-to.component";
import { ApplicationSearchService } from "../../../tabs/applications/shared/application-search.service";
import { catchError, distinctUntilChanged, map } from "rxjs/operators";
import { CRUDOperation } from "../../models/crud-operation-enum.model";
import { BehaviorSubject, throwError } from "rxjs";
import { AppControllerService } from "../../../app-controller.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { OdataQueryService } from "../odata-query/odata-query.service";
import { AppRoutingConstants } from "../../../app-routing.constants";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { AlertType } from "../../models/alert";
import { ApplicationSearchConstants } from "../../../tabs/applications/application-search/application-search-constants";
import { ODataAction } from "../odata-query/odata-action.model";
import { RequestStatusService } from "../request-status/request-status.service";
import { SearchCreatedDateComponent } from "../../../tabs/applications/application-search/search-created-date/search-created-date.component";
import { SearchprojectCyclePvComponent } from "../../../tabs/applications/application-search/modules/pv/search-project-cycle-pv/search-project-cycle-pv.component";
import { SearchPropertyInfoPvComponent } from "../../../tabs/applications/application-search/modules/pv/search-property-info-pv/search-property-info-pv.component";
import { Router } from "@angular/router";
import { SearchStatusComponent } from "../../../tabs/applications/application-search/search-status/search-status.component";
import { SearchOwnerInfoComponent } from "../../../tabs/applications/application-search/search-owner-info/search-owner-info.component";
import { SearchOptionsConstants } from "../../../core/settings/components/search-options/search-options-constants";
import { ApiSearchOptionConstants } from "../../constants/api-constants/api-search-option.constants";
import { ApiApplicationSearchConstants } from "../../constants/api-constants/api-application-search.constants";
import { ApiPropertyValuationValuationBlockConstants } from "../../constants/api-constants/api-property-valuation-valuation-block.constants";
import { ValuationBlockFactorAdjustmentsComponent } from "../../../application/view-application/modules/pv/valuation-block-factor-adjustments/valuation-block-factor-adjustments.component";
import { ValuationBlockStructureTypesComponent } from "../../../application/view-application/modules/pv/valuation-block-structure-types/valuation-block-structure-types.component";
import { ValuationBlockValueAdjustmentsComponent } from "../../../application/view-application/modules/pv/valuation-block-value-adjustments/valuation-block-value-adjustments.component";
import { ValuationBlockAgricultureActivityComponent } from "../../../application/view-application/modules/pv/valuation-block-agriculture-activities/valuation-block-agriculture-activities.component";
import { AttributesAndParametersComponent } from "../../../core/settings/components/attributes-and-parameters/attributes-and-parameters.component";
import { PvprojectCycleComponent } from "../../../core/settings/components/pv-project-cycle/pv-project-cycle.component";
import { ViewBlockPropertiesPvComponent } from "../../../application/view-application/modules/pv/view-block-properties-pv/view-block-properties-pv.component";
import { EsriDataTypeEnum } from "../../models/esri-data-type-enum";
import { SearchStartDateComponent } from "../../../tabs/applications/application-search/search-start-date/search-start-date.component";
import { SearchCategoryComponent } from "../../../tabs/applications/application-search/search-category/search-category.component";
import { AutoUnsub } from "../../decorators/autounsub.decorator";
import { ApplicationsRoutingConstants } from "../../../tabs/applications/applications-routing.constants";
import { AttributesAndParametersService } from "../../../core/settings/components/attributes-and-parameters/shared/services/attributes-and-parameters.service";
import { AppConfig } from "../../../app.config";
import { ModulePrefix } from "../../models/module-prefix.model";
// Not to be sorted!!!! ==> Already in correct sort order
// Please do not rename the enums ==> it will break the SearchOptions Field?Column Settings! Labels can be changed without any impact.
export var PvSearchOptions;
(function (PvSearchOptions) {
    PvSearchOptions["ReferenceNumber"] = "Reference Number";
    PvSearchOptions["MyApplications"] = "My Applications";
    PvSearchOptions["MunicipalValuer"] = "Municipal Valuer";
    PvSearchOptions["AppID"] = "Application ID";
    PvSearchOptions["ApplicationStatus"] = "Application Status";
    PvSearchOptions["ApplicationCategory"] = "Application Category";
    PvSearchOptions["ApplicationsWithoutStartDate"] = "Applications Without Start Date";
    PvSearchOptions["AssignedToUsers"] = "Assigned to";
    PvSearchOptions["UnassignedApplications"] = "Unassigned Applications";
    PvSearchOptions["CreatedDate"] = "Created Date";
    PvSearchOptions["CreatedDateRange"] = "Created Date Range";
    PvSearchOptions["StartDate"] = "Started Date";
    PvSearchOptions["StartDateRange"] = "Started Date Range";
    PvSearchOptions["DaysUntilExpired"] = "Days until Expired";
    PvSearchOptions["OwnerInfo"] = "Owner Information";
    PvSearchOptions["PercentageComplete"] = "Percentage Complete";
    PvSearchOptions["TimeoutStatus"] = "Timeout Status";
    PvSearchOptions["projectCycle"] = "Project Cycle";
    PvSearchOptions["ValuationType"] = "Valuation Type";
    PvSearchOptions["PropertyType"] = "Property Category";
    PvSearchOptions["PropertyInfo"] = "Property Information";
    PvSearchOptions["JobID"] = "Job ID";
})(PvSearchOptions || (PvSearchOptions = {}));
// TODO these columns will change depending on how columns have been configured. This is the default list
export var ApplicationHeadingEnum;
(function (ApplicationHeadingEnum) {
    ApplicationHeadingEnum["ReferenceNumber"] = "Reference Number";
    ApplicationHeadingEnum["Valuer"] = "Valuer";
    ApplicationHeadingEnum["MunicipalValuer"] = "Municipal Valuer";
    ApplicationHeadingEnum["BlockName"] = "Block Name";
    ApplicationHeadingEnum["BlockDecription"] = "Block description";
    ApplicationHeadingEnum["RollName"] = "Roll name";
    ApplicationHeadingEnum["ProjectCycleName"] = "Project cycle name";
    ApplicationHeadingEnum["StartDate"] = "Start Date";
    ApplicationHeadingEnum["ApplicationStatus"] = "Valuation block status";
    ApplicationHeadingEnum["DaysLeft"] = "Days left";
    ApplicationHeadingEnum["LastEditedBy"] = "Last Edited By";
    ApplicationHeadingEnum["LastEditedOn"] = "Last Edited On";
})(ApplicationHeadingEnum || (ApplicationHeadingEnum = {}));
//Check here
export const applicationHeadingLookup = new Map([
    [ApplicationHeadingEnum.ReferenceNumber, "referenceNumber"],
    [ApplicationHeadingEnum.MunicipalValuer, "municipalValuer"],
    [ApplicationHeadingEnum.ProjectCycleName, "propertyCycleName"],
    [ApplicationHeadingEnum.RollName, "rollName"],
    [ApplicationHeadingEnum.BlockDecription, "description"],
    [ApplicationHeadingEnum.StartDate, "startDate"],
    [ApplicationHeadingEnum.ApplicationStatus, "phase"],
    [ApplicationHeadingEnum.DaysLeft, "daysLeft"],
    [ApplicationHeadingEnum.LastEditedBy, "lastEditedBy"],
    [ApplicationHeadingEnum.LastEditedOn, "lastEditedOn"],
]);
export var ApplicationSummaryColumnsEnum;
(function (ApplicationSummaryColumnsEnum) {
    ApplicationSummaryColumnsEnum["ReferenceNumber"] = "Reference Number";
    ApplicationSummaryColumnsEnum["Valuer"] = "Valuer";
    ApplicationSummaryColumnsEnum["Method"] = "method";
    ApplicationSummaryColumnsEnum["RollName"] = "Roll name";
    ApplicationSummaryColumnsEnum["PropertType"] = "Property category";
    ApplicationSummaryColumnsEnum["MunicipalValuer"] = "Municipal Valuer";
    ApplicationSummaryColumnsEnum["ErfNumber"] = "Erf Number";
    ApplicationSummaryColumnsEnum["StartDate"] = "Start Date";
    ApplicationSummaryColumnsEnum["Phase"] = "Block status";
    ApplicationSummaryColumnsEnum["DaysLeft"] = "Days left";
    ApplicationSummaryColumnsEnum["LastEditedBy"] = "Last Edited By";
    ApplicationSummaryColumnsEnum["LastEditedOn"] = "Last Edited On";
})(ApplicationSummaryColumnsEnum || (ApplicationSummaryColumnsEnum = {}));
export const applicationSummaryColumnsLookup = new Map([
    [ApplicationSummaryColumnsEnum.ReferenceNumber, "referenceNumber"],
    [ApplicationSummaryColumnsEnum.MunicipalValuer, "municipalValuer"],
    [ApplicationSummaryColumnsEnum.StartDate, "startDate"],
    [ApplicationSummaryColumnsEnum.Phase, "phase"],
    [ApplicationSummaryColumnsEnum.DaysLeft, "daysLeft"],
    [ApplicationSummaryColumnsEnum.RollName, "rollName"],
    [ApplicationSummaryColumnsEnum.Method, "method"],
    [ApplicationSummaryColumnsEnum.PropertType, "propertyType"],
    [ApplicationSummaryColumnsEnum.LastEditedBy, "lastEditedBy"],
    [ApplicationSummaryColumnsEnum.LastEditedOn, "lastEditedOn"],
]);
export const PvSearchQueryLookup = new Map([
    [PvSearchOptions.AppID, "appId"],
    [PvSearchOptions.ReferenceNumber, "referenceNumber"],
    [PvSearchOptions.PropertyType, "propertyType"],
    [PvSearchOptions.ValuationType, "method"],
    [PvSearchOptions.JobID, "jobId"]
]);
export const PvAdditionalSearchOptions = [PvSearchOptions.MyApplications, PvSearchOptions.AssignedToUsers, PvSearchOptions.UnassignedApplications];
export const PvDateSearchOptions = new Map([
    [PvSearchOptions.CreatedDate, 1],
    [PvSearchOptions.CreatedDateRange, 2]
]);
export const PvStartRangeDateSearchOptions = new Map([
    [PvSearchOptions.StartDate, 1],
    [PvSearchOptions.StartDateRange, 2]
]);
export const PvStatusSearchOptions = new Map([
    [PvSearchOptions.ApplicationStatus, ApplicationSearchConstants.STATUS],
    [PvSearchOptions.PercentageComplete, ApplicationSearchConstants.PERCENT_COMPLETE],
    [PvSearchOptions.DaysUntilExpired, ApplicationSearchConstants.DAYS_UNTIL_EXPIRED],
    [PvSearchOptions.TimeoutStatus, ApplicationSearchConstants.TIMEOUT_STATUS],
]);
export const PvSearchOptionClientHeight = new Map([
    [PvSearchOptions.ReferenceNumber, SearchContainerHeight.Simple],
    [PvSearchOptions.MyApplications, SearchContainerHeight.Simple],
    [PvSearchOptions.AppID, SearchContainerHeight.Simple],
    [PvSearchOptions.ValuationType, SearchContainerHeight.Simple],
    [PvSearchOptions.PropertyType, SearchContainerHeight.Simple],
    [PvSearchOptions.ApplicationStatus, SearchContainerHeight.SingleLine],
    [PvSearchOptions.PercentageComplete, SearchContainerHeight.SingleLine],
    [PvSearchOptions.DaysUntilExpired, SearchContainerHeight.SingleLine],
    [PvSearchOptions.TimeoutStatus, SearchContainerHeight.SingleLine],
    [PvSearchOptions.CreatedDate, SearchContainerHeight.SingleLine],
    [PvSearchOptions.AssignedToUsers, SearchContainerHeight.SingleLine],
    [PvSearchOptions.CreatedDateRange, SearchContainerHeight.SingleLine],
    [PvSearchOptions.MunicipalValuer, SearchContainerHeight.Extended],
    [PvSearchOptions.OwnerInfo, SearchContainerHeight.Extended],
    [PvSearchOptions.projectCycle, SearchContainerHeight.Extended],
    [PvSearchOptions.PropertyInfo, SearchContainerHeight.Extended]
]);
// TODO: don't forget to fix these tables to sync with latest DB changes
// IMPORTANT: these values much match the DB table names and the Property names used by oData entity for PropertyValuation
export var PvSearchOptionTableListEnum;
(function (PvSearchOptionTableListEnum) {
    PvSearchOptionTableListEnum["Application"] = "PV_APPLICATION|Application";
    PvSearchOptionTableListEnum["Property"] = "PV_PROPERTY|Properties";
    PvSearchOptionTableListEnum["Section"] = "PV_SECTION|Sections";
    PvSearchOptionTableListEnum["Block"] = "PV_BLOCK|Blocks";
    PvSearchOptionTableListEnum["ParameterSet"] = "PV_PARAMETERSET|ParameterSets";
    PvSearchOptionTableListEnum["Parameter"] = "PV_PARAMETER|Parameters";
    PvSearchOptionTableListEnum["Valuation"] = "PV_VALUATION|Valuation";
    PvSearchOptionTableListEnum["ValuationBlock"] = "PV_VALUATIONBLOCK|ValuationBlock";
    PvSearchOptionTableListEnum["Deed"] = "PV_DEED|Deed";
    PvSearchOptionTableListEnum["PropertyAttribute"] = "PV_PROPERTYATTRIBUTE|PropertyAttribute";
    PvSearchOptionTableListEnum["PropertyAttributeSpatial"] = "PV_PropertyAttributeSpatial|PropertyAttributeSpatial";
    PvSearchOptionTableListEnum["PropertyFactor"] = "PV_PropertyFactor|PropertyFactor";
    PvSearchOptionTableListEnum["PropertySectionalTitleScheme"] = "PV_PROPERTYSECTIONALTITLESCHEME|PropertySectionalTitleScheme";
    PvSearchOptionTableListEnum["Owner"] = "AFLA_Recipient|Owners";
    PvSearchOptionTableListEnum["Status"] = "AFLA_APPLICATIONSTATUS|Status";
    PvSearchOptionTableListEnum["Applicant"] = "AFLA_Recipient|Applicant";
    PvSearchOptionTableListEnum["ApplicantAgent"] = "AFLA_Recipient|ApplicantAgent";
    PvSearchOptionTableListEnum["Valuer"] = "AFLA_Recipient|Valuer";
    PvSearchOptionTableListEnum["MunicipalValuer"] = "AFLA_Recipient|MunicipalValuer";
})(PvSearchOptionTableListEnum || (PvSearchOptionTableListEnum = {}));
export const PvExpandListForApplicationSearch = ApplicationSearchConstants.APP_SEARCH_EXPAND_FULL_LIST_PV;
// TODO: don't forget to fix these tables to sync with latest DB changes
export const PvTableNameListForSearchOptions = PvSearchOptionTableListEnum.Application
    + "," + PvSearchOptionTableListEnum.Property
    + "," + PvSearchOptionTableListEnum.Section
    + "," + PvSearchOptionTableListEnum.Block
    + "," + PvSearchOptionTableListEnum.ParameterSet
    + "," + PvSearchOptionTableListEnum.Parameter
    + "," + PvSearchOptionTableListEnum.Valuation
    + "," + PvSearchOptionTableListEnum.ValuationBlock
    + "," + PvSearchOptionTableListEnum.Deed
    + "," + PvSearchOptionTableListEnum.PropertyAttribute
    + "," + PvSearchOptionTableListEnum.PropertyAttributeSpatial
    + "," + PvSearchOptionTableListEnum.PropertyFactor
    + "," + PvSearchOptionTableListEnum.PropertySectionalTitleScheme
    + "," + PvSearchOptionTableListEnum.Owner
    + "," + PvSearchOptionTableListEnum.Status
    + "," + PvSearchOptionTableListEnum.Applicant
    + "," + PvSearchOptionTableListEnum.ApplicantAgent
    + "," + PvSearchOptionTableListEnum.Valuer
    + "," + PvSearchOptionTableListEnum.MunicipalValuer;
export var CreateApplicationMenuHeadings;
(function (CreateApplicationMenuHeadings) {
    CreateApplicationMenuHeadings["Details"] = "Details";
    CreateApplicationMenuHeadings["Notes"] = "Notes";
})(CreateApplicationMenuHeadings || (CreateApplicationMenuHeadings = {}));
export var ViewApplicationMenuHeadings;
(function (ViewApplicationMenuHeadings) {
    ViewApplicationMenuHeadings["Details"] = "Details";
    ViewApplicationMenuHeadings["BlockProperties"] = "Block properties";
    ViewApplicationMenuHeadings["FactorAdjustment"] = "Factor adjustment";
    ViewApplicationMenuHeadings["StructureType"] = "Structure type";
    ViewApplicationMenuHeadings["ValueAdjustment"] = "Value adjustment";
    ViewApplicationMenuHeadings["AgricultureActivity"] = "Agriculture activity";
    ViewApplicationMenuHeadings["Objections"] = "Objections";
    ViewApplicationMenuHeadings["Appeals"] = "Appeals";
    ViewApplicationMenuHeadings["Assessment"] = "Assessment";
    ViewApplicationMenuHeadings["Attachments"] = "Attachments";
    ViewApplicationMenuHeadings["Checklist"] = "Checklist";
    ViewApplicationMenuHeadings["Comments"] = "Comments";
    ViewApplicationMenuHeadings["Communication"] = "Communication";
    ViewApplicationMenuHeadings["Conditions"] = "Conditions";
    ViewApplicationMenuHeadings["History"] = "History";
    ViewApplicationMenuHeadings["Invoices"] = "Invoices";
    ViewApplicationMenuHeadings["Notes"] = "Notes";
    ViewApplicationMenuHeadings["RelatedApplicationSearch"] = "Related applications";
    ViewApplicationMenuHeadings["RequiredDocumentsChecklist"] = "Required documents checklist";
    ViewApplicationMenuHeadings["Result"] = "Result";
    ViewApplicationMenuHeadings["ScheduledReminders"] = "Scheduled Reminders";
    ViewApplicationMenuHeadings["Status"] = "Status";
    ViewApplicationMenuHeadings["StepManagement"] = "Step management";
    ViewApplicationMenuHeadings["Survey123"] = "Survey123";
    ViewApplicationMenuHeadings["Timeouts"] = "Timeouts";
    ViewApplicationMenuHeadings["Team"] = "Team";
})(ViewApplicationMenuHeadings || (ViewApplicationMenuHeadings = {}));
export var SettingsMenuHeadings;
(function (SettingsMenuHeadings) {
    SettingsMenuHeadings["AvailableSurvey123s"] = "Available survey123s";
    SettingsMenuHeadings["Lookups"] = "Lookups";
    SettingsMenuHeadings["MapConfig"] = "Map services";
    SettingsMenuHeadings["NonWorkingDays"] = "Non-working days";
    SettingsMenuHeadings["AttachmentTypes"] = "Attachment types";
    SettingsMenuHeadings["Recipients"] = "Recipients";
    SettingsMenuHeadings["RecipientGroups"] = "Recipient groups";
    SettingsMenuHeadings["Reports"] = "Reports";
    SettingsMenuHeadings["StepMetaData"] = "Step metadata";
    SettingsMenuHeadings["Tariffs"] = "Tariffs";
    SettingsMenuHeadings["Templates"] = "Templates";
    SettingsMenuHeadings["NotificationTemplates"] = "Notification templates";
    SettingsMenuHeadings["ModuleRoles"] = "Module roles";
    // AFLAPortalDocuments = "Afla portal documents",
    SettingsMenuHeadings["SearchOptions"] = "Search options";
    SettingsMenuHeadings["SearchSettings"] = "Search settings";
    SettingsMenuHeadings["BackupRestore"] = "Backup and restore";
    SettingsMenuHeadings["ArcGISItems"] = "ArcGIS items";
    // AFLAPortalMessagesAndPages = "AFLA portal messages and pages",
    SettingsMenuHeadings["ValuationRun"] = "Pv G.V Project cycle";
    SettingsMenuHeadings["ValuationRoll"] = "Pv G.V roll";
    SettingsMenuHeadings["AttributesAndParameters"] = "Pv G.V Attributes and parameters";
    SettingsMenuHeadings["InvoiceTemplates"] = "Invoice templates";
    SettingsMenuHeadings["Stamps"] = "Stamps";
    SettingsMenuHeadings["ApplicationWorkflowUpgrade"] = "Application workflow upgrade";
})(SettingsMenuHeadings || (SettingsMenuHeadings = {}));
export const PvRequiredMapFields = [{
        mapName: "Property",
        fields: [
            { name: "OBJECTID", type: EsriDataTypeEnum.oid },
            { name: "SgCode", type: EsriDataTypeEnum.string },
            { name: "ErfNo", type: EsriDataTypeEnum.string },
            { name: "FarmNo", type: EsriDataTypeEnum.string },
            { name: "PtnNum", type: EsriDataTypeEnum.string },
            { name: "Allotment", type: EsriDataTypeEnum.string },
            { name: "PropertyDescription", type: EsriDataTypeEnum.string },
            { name: "Address", type: EsriDataTypeEnum.string },
            { name: "TotalValue", type: EsriDataTypeEnum.integer },
            { name: "HasGeometry", type: EsriDataTypeEnum.integer },
            { name: "ErfSize", type: EsriDataTypeEnum.integer },
            { name: "TitleDeed", type: EsriDataTypeEnum.string },
            { name: "SectionalTitleSchemeID", type: EsriDataTypeEnum.string },
            { name: "Type", type: EsriDataTypeEnum.string },
            { name: "LegalStatus", type: EsriDataTypeEnum.string },
            { name: "FloorNo", type: EsriDataTypeEnum.string },
            { name: "FloorName", type: EsriDataTypeEnum.string },
            { name: "SgDiagramNo", type: EsriDataTypeEnum.string },
            { name: "UnitNumber", type: EsriDataTypeEnum.integer },
            { name: "Registered", type: EsriDataTypeEnum.smallInteger },
            { name: "SgCodeExternal", type: EsriDataTypeEnum.string },
            { name: "PremiseID", type: EsriDataTypeEnum.string },
            { name: "AccountNo", type: EsriDataTypeEnum.string },
            { name: "ZoningCategory", type: EsriDataTypeEnum.string },
            { name: "Shape", type: EsriDataTypeEnum.geometry },
            { name: "Shape_Area", type: EsriDataTypeEnum.double },
            { name: "Shape_Length", type: EsriDataTypeEnum.double }
        ]
    }];
let PvStrategyService = class PvStrategyService extends AflaModuleStrategyService {
    static { PvStrategyService_1 = this; }
    saShortDatePipe;
    applicationSearchService;
    attributesAndParametersService;
    oDataQueryService;
    requestStatusService;
    http;
    appController;
    router;
    buildingUseSearchOptions;
    overdueApplicationExpandFields = "status, applicant";
    showApplicantAgentForModule = true;
    requiredMapFields;
    createApplicationMenuHeadings;
    overrideMapDefault = {};
    viewApplicationComponentLookup;
    name = ModuleConfig.PropertyValuation;
    modulePrefix = ModulePrefix.PropertyValuation;
    searchQueryLookup;
    defaultSearchColumns;
    searchOptions;
    applicationEndpoint;
    extendedSimpleSearchOptions;
    dateSearchOptions;
    RangeSearchOptions;
    statusSearchOptions;
    groupSearchOptions;
    clientHeightMap;
    createApplicationComponentLookup;
    advancedSearchComponentLookup;
    viewApplicationMenuHeadings;
    applicationSummaryColumnsMap;
    // column headers are dynamic
    applicationTableColumnMap = new BehaviorSubject(null);
    applicationTableColumnMapObservable = this.applicationTableColumnMap.asObservable();
    applicationServiceUrl = ApiPropertyValuationValuationBlockConstants.URL;
    form;
    lookups = new Map();
    userId;
    moduleUsers;
    expandListForApplicationSearch = PvExpandListForApplicationSearch;
    expandListForApplicationSearchFullList = PvExpandListForApplicationSearch;
    searchOptionTableNameList = PvTableNameListForSearchOptions;
    customApplicationTableColumnMap = null;
    selectedSearchOptionLookup;
    searchOptionsWithCustomColumns = [];
    searchOptionsFieldList;
    searchOptionsMap;
    isPrevSavedSearch = false;
    aflaPortalConfigurableMessages = [
        "Welcome help",
        "Property Help",
        "Applicant Help",
        "Welcome page",
        "Agent help",
        "Summary help",
        "Create application status page",
        "View application status page",
        "Communication help",
    ];
    setApplicantAndApplicantAgentAction = ApiPropertyValuationValuationBlockConstants.FUNCTION_SET_APPLICANT_AND_APPLICANT_AGENT;
    settingsMenuHeadings;
    settingsComponentLookup;
    propertiesPageHeading = "Properties";
    moduleRequiredMaps = ["Property"];
    stampOptions = [];
    previousApplication = null;
    dynamicTitle = {
        Applications: "Valuation rolls",
        Application: "Valuation roll",
        CreateApplicationLinkText: "Create valuation roll",
        ViewApplicationTitle: "View valuation roll",
        CreateApplicationTitle: "Create valuation roll",
    };
    statusColumn = "status/ workflowSection";
    createApplicationPvSubscription;
    draftApplicationPvSubscription;
    getValuationMethodsSubscription;
    methodAliases = [];
    valuationMethods;
    constructor(saShortDatePipe, applicationSearchService, attributesAndParametersService, oDataQueryService, requestStatusService, http, appController, router) {
        super();
        this.saShortDatePipe = saShortDatePipe;
        this.applicationSearchService = applicationSearchService;
        this.attributesAndParametersService = attributesAndParametersService;
        this.oDataQueryService = oDataQueryService;
        this.requestStatusService = requestStatusService;
        this.http = http;
        this.appController = appController;
        this.router = router;
        this.initForm();
        this.applicationEndpoint = ApiApplicationSearchConstants.PROPERTY_VALUATION_ENDPOINT;
        this.createApplicationMenuHeadings = CreateApplicationMenuHeadings;
        this.viewApplicationMenuHeadings = ViewApplicationMenuHeadings;
        this.settingsMenuHeadings = SettingsMenuHeadings;
        this.moduleRequiredMaps = ["Property"];
        this.requiredMapFields = PvRequiredMapFields;
        super.init();
    }
    static getRecipientFullName(firstName, surname) {
        if (!firstName && !surname) {
            return "";
        }
        if (!firstName) {
            return surname;
        }
        return `${firstName} ${surname}`;
    }
    static getRecipientName(recipient) {
        if (!recipient) {
            return "";
        }
        return this.getRecipientFullName(recipient.name, recipient.surname);
    }
    // the format for a column filter on an child table is:
    //    EQUALS ==> applicantAgent/any(m:m/name eq 'xxxx')
    //    CONTAINS with tolower ==> applicantAgent/any(b:contains(tolower(b/name),'xxxx'))
    static buildColumnFilter(text, filter) {
        let column;
        let condition;
        if (filter) {
            column = filter.trim();
            condition = `contains(tolower(cast(${column.trim()},'Edm.String')),'${text.trim().toLowerCase()}')`;
        }
        else {
            if (filter &&
                (filter === ApplicationSearchConstants.NAME ||
                    filter === ApplicationSearchConstants.SURNAME)) {
                column = filter.trim();
                condition = `contains(tolower(cast(${column},'Edm.String')),'${text.trim().toString()}')`;
            }
            else {
                const stringArray = text.trim().split(" ");
                if (stringArray.length == 1) {
                    condition = `municipalValuer/any(c: c/${ApplicationSearchConstants.NAME} eq '${stringArray[0].trim()}' or c/${ApplicationSearchConstants.SURNAME} eq '${stringArray[0].trim()}')`;
                }
                else if (stringArray.length > 1) {
                    condition = `municipalValuer/any(c: c/${ApplicationSearchConstants.NAME} eq '${stringArray[0].trim()}' or c/${ApplicationSearchConstants.SURNAME} eq '${stringArray[1].trim()}' or
                      c/${ApplicationSearchConstants.SURNAME} eq '${stringArray[0].trim()}' or c/${ApplicationSearchConstants.NAME} eq '${stringArray[1].trim()}')`;
                }
            }
        }
        return `${condition} and eLodgementComplete eq true`;
    }
    static buildExpand(params, top) {
        params = params.set(ODataAction.Expand, PvExpandListForApplicationSearch);
        params = params.set(ODataAction.Top, top);
        params = params.set(ODataAction.OrderBy, "startDate ne null desc, startDate desc, appId desc");
        return params;
    }
    static getFirstRecipient(recipients) {
        if (recipients && recipients.length > 0) {
            return recipients[0];
        }
    }
    populateValuationMethods() {
        this.getValuationMethods();
    }
    buildListFilter(list, column) {
        const params = PvStrategyService_1.buildExpand(new HttpParams(), this.appController.fetchRecordCountValue);
        return this.oDataQueryService.buildFilterFromArray(params, column, list);
    }
    getStatusForModule(moduleID, statusField) {
        return this.applicationSearchService.getStatusForModule(moduleID, statusField);
    }
    getUsersForModule(moduleID) {
        return this.applicationSearchService.getUsersForModule(moduleID);
    }
    getApplicationTypesForModule(moduleID) {
        return this.applicationSearchService.getApplicationTypesForModule(moduleID);
    }
    initializeSearchQueryLookup() {
        this.searchQueryLookup = PvSearchQueryLookup;
    }
    initializeAdditionalSearchLookup() {
        this.extendedSimpleSearchOptions = PvAdditionalSearchOptions;
    }
    initializeApplicationSummaryColumnsMap() {
        this.applicationSummaryColumnsMap = applicationSummaryColumnsLookup;
    }
    initializeSearchOptionsLookup() {
        this.searchOptions = new Array();
        this.searchOptions.push(..._.values(PvSearchOptions));
        // this is used for the SearchOptions settings
        this.searchOptionsMap = new Map();
        for (const [key, value] of Object.entries(PvSearchOptions)) {
            this.searchOptionsMap.set(key, value);
        }
        // default column list if search option types does not have a default
        this.defaultSearchColumns = applicationHeadingLookup;
    }
    initializeDateSearchOptions() {
        this.dateSearchOptions = PvDateSearchOptions;
        this.RangeSearchOptions = PvStartRangeDateSearchOptions;
    }
    initializeStatusSearchOptions() {
        this.statusSearchOptions = PvStatusSearchOptions;
        this.clientHeightMap = PvSearchOptionClientHeight;
    }
    initializeGroupSearchOptions = () => {
    };
    getFieldListForSearchOptions(moduleId) {
        const params = {
            $filter: PvStrategyService_1.buildModuleIDFilter(moduleId),
            $expand: SearchOptionsConstants.SEARCH_OPTIONS_EXPAND,
            $orderby: SearchOptionsConstants.SEARCH_OPTIONS_COLUMNS_ORDERBY,
        };
        const url = `${ApiSearchOptionConstants.URL}`;
        return this.http.get(url, { params }).pipe(map((response) => {
            this.searchOptionsWithCustomColumns = [];
            this.searchOptionsFieldList = response.value;
            this.searchOptionsFieldList.forEach((option) => {
                const searchOptionLookup = this.getSearchOptionLookup(option.searchOption);
                // @ts-expect-error/ because
                if (this.searchOptionsWithCustomColumns.indexOf(searchOptionLookup) < 0) {
                    // @ts-ignore
                    this.searchOptionsWithCustomColumns.push(searchOptionLookup);
                }
            });
            return response.value;
        }));
    }
    defaultSearchModel(application) {
        return {
            id: application.id,
            appId: application.appId,
            jobId: application.jobId,
            method: application.method,
            description: application.description,
            rollName: application.valuationRoll ? application.valuationRoll.name : "",
            propertyCycleName: application.valuationRoll ? application.valuationRoll?.projectCycle?.name : "",
            propertyType: application.propertyType,
            referenceNumber: application.referenceNumber,
            agent: PvStrategyService_1.getRecipientName(PvStrategyService_1.getFirstRecipient(application.municipalValuer)),
            phase: "",
            SgCode: "",
            startDate: application.createdDate !== null
                ? this.saShortDatePipe.transform(application.startDate)
                : "",
            applicationStatus: application.status?.workflowSection,
            daysLeft: application.status?.daysUntilExpired,
            lastEditedBy: this.getLastEditedByUser(application.lastEditedUser),
            municipalValuer: PvStrategyService_1.getRecipientName(PvStrategyService_1.getFirstRecipient(application.municipalValuer)),
            lastEditedOn: application.lastEditedDate !== null
                ? this.saShortDatePipe.transform(application.lastEditedDate)
                : "",
            moduleId: application.moduleId,
        };
    }
    getLastEditedByUser(lastEditedUser) {
        return lastEditedUser
            ? `${lastEditedUser.lastName}, ${lastEditedUser.firstName}`
            : "";
    }
    getApplicationFieldValue(application, appGroup, fieldName) {
        let fieldValue;
        for (const [key, value] of Object.entries(application)) {
            if (!fieldValue && appGroup.toLowerCase() === "application") {
                if (key.toLowerCase() === fieldName.toLowerCase()) {
                    fieldValue = value;
                    break;
                }
            }
            else {
                if (!fieldValue && key.toLowerCase() === appGroup.toLowerCase()) {
                    // some applications may have null lower order properties e.g. Status
                    if (value) {
                        const group = value[0] ? value[0] : value;
                        for (const [groupKey, groupValue] of Object.entries(group)) {
                            switch (appGroup.toLowerCase()) {
                                case "municipalvaluer":
                                case "assistantvaluers":
                                case "applicant":
                                case "applicantagent":
                                    if (groupKey.toLowerCase() === fieldName.toLowerCase()) {
                                        fieldValue = groupValue;
                                        break;
                                    }
                                    break;
                                case "status":
                                    if (groupKey.toLowerCase() === fieldName.toLowerCase()) {
                                        switch (fieldName.toLowerCase()) {
                                            case "assignedto":
                                            case "createdby":
                                                // these fields will be handled in the user section below
                                                break;
                                            default:
                                                fieldValue = groupValue;
                                                break;
                                        }
                                        break;
                                    }
                                    break;
                                // the following properties can be multiple values - we cannot use ObjectUtils.getCommaSeparatedValuesFromListForKey because it is case sensitive
                                case "properties":
                                    if (groupKey.toLowerCase() === fieldName.toLowerCase()) {
                                        fieldValue = fieldValue
                                            ? (fieldValue += ", " + groupValue)
                                            : groupValue;
                                    }
                                    break;
                            }
                        }
                    }
                }
                if (fieldValue)
                    break;
            }
        }
        if (!fieldValue)
            fieldValue = "";
        if (fieldName.toLowerCase().endsWith("date") ||
            fieldName.toLowerCase().startsWith("date")) {
            fieldValue = fieldValue ? this.saShortDatePipe.transform(fieldValue) : "";
        }
        else {
            switch (fieldName.toLowerCase()) {
                case "lasteditedby":
                    fieldValue = this.getUserName(application.lastEditedUser);
                    break;
                case "createdby":
                    fieldValue = application.status
                        ? this.getUserNameFromId(application.status.createdBy)
                        : "";
                    break;
                case "assignedto":
                    fieldValue = application.status
                        ? this.getUserNameFromId(application.status.assignedTo)
                        : "";
                    break;
                case "createduserid":
                    fieldValue = this.getUserName(application.createdSystemUser);
                    break;
            }
        }
        return fieldValue;
    }
    customColumnSearchModel(application, columnList, isPrevSavedSearch = false) {
        // need to reset the column map if the search options customised columns have been updated
        // need to reset the column map if the search options customised columns have been updated
        if ((this.customApplicationTableColumnMap.size !== 0 &&
            columnList.length !== this.customApplicationTableColumnMap.size) ||
            isPrevSavedSearch) {
            this.customApplicationTableColumnMap.clear();
            this.isPrevSavedSearch = false;
        }
        let resetHeadings = this.customApplicationTableColumnMap.size === 0;
        const appDetails = {};
        if (columnList.length > 0) {
            columnList.forEach((column) => {
                const fieldAlias = column.moduleField.fieldAlias;
                const fieldName = column.moduleField.fieldName;
                const tableLookup = this.getSearchOptionLookup(`${column.moduleField.tableAlias}`);
                const appGroup = this.getApplicationTableProperty(`${column.moduleField.tableName}|${tableLookup}`);
                const appProperty = `${appGroup.toLowerCase()}${fieldName.toLowerCase()}`;
                appDetails[appProperty] = this.getApplicationFieldValue(application, tableLookup, fieldName);
                if (resetHeadings)
                    this.customApplicationTableColumnMap.set(fieldAlias, appProperty);
            });
            // standard fields to add in case the user did not add them
            // @ts-ignore
            appDetails.id = application.id;
            // @ts-ignore
            appDetails.moduleId = application.moduleId;
            // @ts-ignore
            appDetails.jobId = application.jobId;
            // @ts-ignore
            appDetails.appId = application.appId;
            // only set the headings once for the search
            if (resetHeadings) {
                this.changeAppTableColumnMap(this.customApplicationTableColumnMap);
                resetHeadings = false;
            }
            return appDetails;
        }
        else
            return this.defaultSearchModel(application);
    }
    getApplicationTableProperty(tableName) {
        let property = "";
        for (const [tableKey, tableValue] of Object.entries(PvSearchOptionTableListEnum)) {
            if (tableValue.toLowerCase() === tableName.toLowerCase()) {
                // @ts-ignore
                property = tableKey;
                break;
            }
        }
        return property;
    }
    getUserNameFromId(userId) {
        let userName = "";
        if (userId) {
            this.applicationSearchService.moduleUsers.forEach((user) => {
                if (Number(user.id) === userId)
                    userName = `${user.lastName}, ${user.firstName}`;
            });
        }
        return userName;
    }
    getUserName(user) {
        return user ? `${user.lastName}, ${user.firstName}` : "";
    }
    getCustomApplicationSearchModel(searchOptionLookup) {
        // identify columnList for specific search option
        return this.applicationSearchService.getSearchOptionColumnList(this, searchOptionLookup);
    }
    mapFromApplicationEntityToApplicationSearchModel(application) {
        if (application) {
            return this.defaultSearchModel(application);
        }
    }
    initializeSettingsComponents() {
        this.settingsComponentLookup = new Map([
            [
                SettingsMenuHeadings.AttributesAndParameters,
                AttributesAndParametersComponent,
            ],
            [SettingsMenuHeadings.ValuationRun, PvprojectCycleComponent],
        ]);
    }
    initializeViewApplicationComponents() {
        this.viewApplicationComponentLookup = new Map([
            [ViewApplicationMenuHeadings.Details, ViewApplicationDetailsPvComponent],
            [
                ViewApplicationMenuHeadings.BlockProperties,
                ViewBlockPropertiesPvComponent,
            ],
            [
                ViewApplicationMenuHeadings.FactorAdjustment,
                ValuationBlockFactorAdjustmentsComponent,
            ],
            [
                ViewApplicationMenuHeadings.StructureType,
                ValuationBlockStructureTypesComponent,
            ],
            [
                ViewApplicationMenuHeadings.ValueAdjustment,
                ValuationBlockValueAdjustmentsComponent,
            ],
            [
                ViewApplicationMenuHeadings.AgricultureActivity,
                ValuationBlockAgricultureActivityComponent,
            ],
        ]);
    }
    initializeCreateApplicationComponents() {
        this.createApplicationComponentLookup = new Map([
            [
                CreateApplicationMenuHeadings.Details,
                CreateApplicationDetailsPvComponent,
            ],
        ]);
    }
    initializeAdvancedApplicationSearchComponents() {
        this.advancedSearchComponentLookup = new Map([
            // [PvSearchOptions.ApplicantAgent, SearchApplicantAgentComponent],
            [PvSearchOptions.AssignedToUsers, SearchAssignedToComponent],
            [PvSearchOptions.CreatedDate, SearchCreatedDateComponent],
            [PvSearchOptions.CreatedDateRange, SearchCreatedDateComponent],
            [PvSearchOptions.StartDate, SearchStartDateComponent],
            [PvSearchOptions.StartDateRange, SearchStartDateComponent],
            // [PvSearchOptions.ApplicantInfo, SearchApplicantInfoComponent],
            [PvSearchOptions.PercentageComplete, SearchStatusComponent],
            [PvSearchOptions.ApplicationStatus, SearchStatusComponent],
            [PvSearchOptions.ApplicationCategory, SearchCategoryComponent],
            [PvSearchOptions.TimeoutStatus, SearchStatusComponent],
            [PvSearchOptions.DaysUntilExpired, SearchStatusComponent],
            [PvSearchOptions.OwnerInfo, SearchOwnerInfoComponent],
            [PvSearchOptions.projectCycle, SearchprojectCyclePvComponent],
            [PvSearchOptions.PropertyInfo, SearchPropertyInfoPvComponent],
        ]);
    }
    getSearchOptionLookup(selectedSearchOption) {
        const keys = [...this.searchOptionsMap.entries()]
            .filter(({ 1: v }) => v === selectedSearchOption)
            .map(([k]) => k);
        return keys.length > 0 ? keys[0].toString() : selectedSearchOption;
    }
    initializeApplicationTableColumnMap() {
        this.changeAppTableColumnMap(this.customApplicationTableColumnMap
            ? this.customApplicationTableColumnMap
            : applicationHeadingLookup);
    }
    changeAppTableColumnMap(tableColumnMap) {
        this.applicationTableColumnMap.next(tableColumnMap);
    }
    doSearchApplicationsByUser(userId, moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchByUser(userId, moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appController.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doSearchApplicationsByResponsiblePerson(userId, moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchByUser(userId, moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appController.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doSearchUnassignedApplications(moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchByUnassignedApplication(moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appController.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doSearchApplicationsWithoutStartDate(moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchApplicationsWithoutStartDate(moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "appId", true, "appId")), catchError((error) => {
            this.appController.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doApplicationSearch(search, moduleID, pageHeading, withDefaultColumns) {
        const column = this.getEntityColumn(search.column);
        // @ts-ignore
        return this.applicationSearchService
            .searchApplicationUsingSimpleSearch(search.text, column, this, moduleID, withDefaultColumns)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appController.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    getApplicationsQuery(params) {
        return this.http.get(AppRoutingConstants.createEndpointRoutev2(this.applicationEndpoint), { params });
    }
    getApplicationsQueryExtended(params, extendedEndPoint) {
        return this.http.get(AppRoutingConstants.createEndpointRoutev2(this.applicationEndpoint, extendedEndPoint), { params });
    }
    getApplicationsSearchRequestWithAdditionalFilters(text, filter, moduleID) {
        let params = PvStrategyService_1.buildExpand(new HttpParams(), this.appController.fetchRecordCountValue);
        params = this.oDataQueryService.filter(params, AflaModuleStrategyService.buildModuleIDFilter(moduleID), PvStrategyService_1.buildColumnFilter(text, filter));
        return this.getApplicationsQuery(params);
    }
    buildApplicationSearchBaseRequest(moduleID) {
        let params = PvStrategyService_1.buildExpand(new HttpParams(), this.appController.fetchRecordCountValue);
        params = this.oDataQueryService.filter(params, PvStrategyService_1.buildModuleIDFilter(moduleID));
        return this.getApplicationsQuery(params);
    }
    buildDashboardApplicationsSearch(moduleID, dashboardFilter) {
        let params = PvStrategyService_1.buildExpand(new HttpParams(), this.appController.fetchRecordCountValue);
        params = this.applicationSearchService.dashboardSearch(params, dashboardFilter, moduleID);
        return this.getApplicationsQuery(params);
    }
    postApplicationService(params) {
        return this.http.post(ApiPropertyValuationValuationBlockConstants.URL, params);
    }
    getDraftApplicationService(moduleId) {
        const params = {
            $filter: `moduleId eq ${moduleId} and deleted eq false`,
        };
        return this.http.get(ApiPropertyValuationValuationBlockConstants.DRAFT_URL, { params });
    }
    postDraftApplicationService(params) {
        return this.http.post(ApiPropertyValuationValuationBlockConstants.DRAFT_URL, params);
    }
    getSelectedApplicationSummaryExpand() {
        return "status, municipalValuer, valuationRoll($expand=projectCycle),properties,properties($expand=appeal), properties($expand=objection), auditActions($filter=action eq 'Execute Step' and component eq 'Workflow' ),properties($expand=owners),properties($expand=valuations($filter=not contains(tolower(status),'rejected');$orderby=date desc)), lastEditedUser";
    }
    getSearchUrlForModule(selectedSearchOption) {
        switch (selectedSearchOption) {
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_BY_USER:
                return ApiApplicationSearchConstants.FUNCTION_GET_PV_APPLICATIONS_BY_USER;
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_CREATED_BY_USER:
                return ApiApplicationSearchConstants.FUNCTION_GET_PV_APPLICATIONS_CREATED_BY_USER;
        }
    }
    getSearchResponsiblePersonUrlForModule(selectedSearchOption) {
        switch (selectedSearchOption) {
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_BY_RESPONSIBLEPERSON:
                return ApiApplicationSearchConstants.FUNCTION_GET_PV_APPLICATIONS_BY_RESPONSIBLEPERSON;
        }
    }
    generateInvoiceReportService(applicationId, invoiceID, canDownloadInPortal = false) {
        const params = {
            invoiceId: invoiceID,
            canDownloadInPortal
        };
        return this.http.get(`${ApiPropertyValuationValuationBlockConstants.URL}/${applicationId}/`, { responseType: "blob", params });
    }
    getRequiredDocumentsChecklist(applicationId, jobId) {
        const params = {
            $filter: jobId,
        };
        return this.http
            .get(`${ApiPropertyValuationValuationBlockConstants.URL}/${applicationId}/${ApiPropertyValuationValuationBlockConstants.FUNCTION_GET_GENERATE_REQUIRED_DOCUMENTS_CHECKLIST}`, { params })
            .pipe(map((data) => {
            return data.value;
        }));
    }
    getExternalLinks(moduleId, jobId, category) {
        const params = {
            jobId,
            category
        };
        return this.http.get(`${ApiPropertyValuationValuationBlockConstants.URL}/${moduleId}/${ApiPropertyValuationValuationBlockConstants.FUNCTION_GET_EXTERNAL_LINKS}`, { params })
            .pipe(map((data) => {
            return data.value;
        }));
    }
    getDraftApplication() {
        return this.getDraftApplicationService(+this.appController.selectedModuleID);
    }
    saveDraftApplication() {
        var draftFormObject = this.form.getRawValue();
        const draftDescription = draftFormObject.detailsForm.description ? draftFormObject.detailsForm.description : "Draft application";
        const draftMethod = draftFormObject.detailsForm.valuationBlockMethodSelect ? draftFormObject.detailsForm.valuationBlockMethodSelect.value : null;
        const draftValidationRoll = draftFormObject.detailsForm.valuationRollSelect ? draftFormObject.detailsForm.valuationRollSelect : null;
        var draftFormJson = JSON.stringify(draftFormObject);
        const params = {
            description: draftDescription,
            method: draftMethod,
            valuationRollId: +draftValidationRoll,
            moduleId: +this.appController.selectedModuleID,
            jsonPayload: draftFormJson
        };
        this.draftApplicationPvSubscription =
            this.postDraftApplicationService(params).subscribe({
                next: (response) => {
                    this.appController.showMessage("Draft saved successfully", AlertType.Success);
                },
                error: (error) => {
                    this.appController.handleServerErrorMessage("application", error, CRUDOperation.Add);
                },
            });
        // this.form.setValue(draftForm);
    }
    /**
     * On click method to build and submit an application
     */
    createApplication() {
        this.requestStatusService.showBusySpinner("CreatePvApplication");
        const application = this.buildApplication();
        if (application) {
            this.createApplicationPvSubscription =
                this.postApplicationService(application).subscribe({
                    next: (savedApplication) => {
                        this.appController.showMessage(PvStrategyService_1.successMessage(savedApplication.jobId), AlertType.Success);
                        this.resetForm();
                        this.requestStatusService.removeBusySpinner("CreatePvApplication");
                        this.router.navigate([
                            AppRoutingConstants.ROUTE_SEPERATOR + ApplicationsRoutingConstants.REFRESH_ROUTE,
                            {
                                jobId: savedApplication.jobId,
                                moduleId: this.appController.selectedModuleID,
                                type: ApplicationsRoutingConstants.REFRESH_VIEW_APPLICATION_ROUTE
                            }
                        ]);
                    },
                    error: (error) => {
                        this.requestStatusService.removeBusySpinner("CreatePvApplication");
                        this.appController.handleServerErrorMessage("application", error, CRUDOperation.Add);
                    },
                });
        }
        else {
            this.requestStatusService.removeBusySpinner("CreatePvApplication");
        }
    }
    getApplicationGeometries(jobID, moduleID) {
        const params = {
            $select: "shape",
            $filter: `jobId eq ${+jobID} and moduleId eq ${+moduleID}`
        };
        return this.http.get(AppRoutingConstants.createEndpointRoutev2(this.applicationEndpoint), { params });
    }
    resetForm() {
        this.form.reset();
        this.form.get("noteForm").get("notes").clear();
    }
    getEntityColumn(searchColumn) {
        switch (searchColumn) {
            case SharedConstants.SEARCH_BY_DEFAULT:
                return SharedConstants.SEARCH_BY_DEFAULT;
            case SharedConstants.DASHBOARD_FILTERS.LatestApplications:
                return SharedConstants.DASHBOARD_FILTERS.LatestApplications;
            case SharedConstants.DASHBOARD_FILTERS.OverdueApplications:
                return SharedConstants.DASHBOARD_FILTERS.OverdueApplications;
            case SharedConstants.DASHBOARD_FILTERS.OpenApplications:
                return SharedConstants.DASHBOARD_FILTERS.OpenApplications;
            case SharedConstants.DASHBOARD_FILTERS.ClosedApplications:
                return SharedConstants.DASHBOARD_FILTERS.ClosedApplications;
            case SharedConstants.DASHBOARD_FILTERS.TotalApplications:
                return SharedConstants.DASHBOARD_FILTERS.TotalApplications;
            case SharedConstants.DASHBOARD_FILTERS.ApplicationStatus:
                return this.statusColumn;
            default:
                return this.searchQueryLookup.get(searchColumn);
        }
    }
    /**
     * Create application form
     */
    initForm() {
        this.form = new FormGroup({
            detailsForm: new FormGroup({
                referenceNumber: new FormControl(null),
                valuationRollSelect: new FormControl(null, [Validators.required]),
                description: new FormControl(null, [Validators.required]),
                valuationReason: new FormControl(null),
                valuationBlockMethodSelect: new FormControl(null, [
                    Validators.required,
                ]),
                valuationSplitMethodForm: new FormArray([]),
                propertyTypeSelect: new FormControl(null, [Validators.required]),
            }),
            // valuerForm: new FormGroup({
            //   municipalValuerRecipient: new FormControl(null, [Validators.required]),
            //   assistantValuerRecipient: new FormControl({ recipients: [] }),
            //   dataCollectorRecipient: new FormControl({ recipients: [] }),
            // }),
            // propertiesForm: new FormGroup({
            //   properties: new FormArray(
            //     [],
            //     [Validators.minLength(1), Validators.required]
            //   ),
            //   shape: new FormControl(null, [Validators.required]),
            //   parentBlockId: new FormControl(null),
            //   salesAreaShape: new FormControl(null),
            //   importParentAttributesParameters: new FormControl(false),
            //   valuationBlockProperties: new FormControl(null),
            //   salesAreaProperties: new FormControl(null),
            // }),
            noteForm: new FormGroup({
                newNote: new FormControl(null),
                notes: new FormArray([]),
            }),
        });
    }
    getValuationMethods() {
        const params = {
            $filter: `moduleId eq ${this.appController.selectedModuleID}  and name eq 'ValuationMethod'`,
        };
        this.getValuationMethodsSubscription = this.attributesAndParametersService
            .getValuationMethods(params)
            .subscribe({
            next: (response) => {
                const valuationMethods = [];
                if (response && response.value.length > 0) {
                    response.value.forEach((item) => {
                        const option = JSON.parse(item.content);
                        if (!option.value.toLowerCase().includes("hybrid")) {
                            valuationMethods.push(option);
                        }
                    });
                }
                const methodAliases = AppConfig.settings.propertyValuation.methodAliases;
                valuationMethods.forEach((x) => {
                    for (const [key, value] of Object.entries(methodAliases)) {
                        if (key === x.value) {
                            x.code = value;
                        }
                    }
                });
                this.valuationMethods = valuationMethods.sort((a, b) => a.value?.localeCompare(b?.value));
            },
        });
    }
    /**
     * Builds an instance of a property valuation application
     * @returns IPvApplication
     */
    buildApplication() {
        // Get municipal valuer from form
        // const municipalValuerFormValue = this.form
        //   .get("valuerForm")
        //   .get("municipalValuerRecipient").value;
        // const municipalValuer = RecipientUtils.removeRecipientProperties(
        //   municipalValuerFormValue
        // );
        // const assistantValuerFormValue = this.form
        //   .get("valuerForm")
        //   .get("assistantValuerRecipient").value;
        // const dataCollectorFormValue = this.form
        //   .get("valuerForm")
        //   .get("dataCollectorRecipient").value;
        // let assistantValuers: IRecipient[] = [];
        // if (
        //   assistantValuerFormValue !== undefined &&
        //   assistantValuerFormValue !== null &&
        //   assistantValuerFormValue.hasOwnProperty("recipients")
        // ) {
        //   assistantValuers = assistantValuerFormValue.recipients;
        //   assistantValuers.forEach((assistant) => {
        //     assistant = RecipientUtils.removeRecipientProperties(assistant);
        //   });
        // }
        // let dataCollectors: IRecipient[] = [];
        // if (
        //   dataCollectorFormValue !== undefined &&
        //   dataCollectorFormValue !== null &&
        //   dataCollectorFormValue.hasOwnProperty("recipients")
        // ) {
        //   dataCollectors = dataCollectorFormValue.recipients;
        //   dataCollectors.forEach((dataCollector) => {
        //     RecipientUtils.removeRecipientProperties(dataCollector);
        //   });
        // }
        // const shape = this.form.get("propertiesForm").get("shape").value;
        // const importParentAttributesParameter = this.form
        //   .get("propertiesForm")
        //   .get("importParentAttributesParameters").value;
        const methodName = this.form
            .get("detailsForm")
            .get("valuationBlockMethodSelect").value?.value;
        const tempMethod = this.valuationMethods.find((x) => x.code == methodName);
        const application = {
            deleted: false,
            referenceNumber: "",
            shape: null,
            wkid: 102100,
            moduleId: Number(this.appController.selectedModuleID),
            description: this.form.get("detailsForm").get("description").value,
            valuationRollId: Number(this.form.get("detailsForm").get("valuationRollSelect").value),
            method: tempMethod ? tempMethod.value.toString() : methodName, // error
            propertyType: this.form.get("detailsForm").get("propertyTypeSelect")
                .value,
            valuationReason: this.form.get("detailsForm").get("valuationReason")
                .value,
            // municipalValuer: [municipalValuer],
            // assistantValuers,
            // dataCollectors,
            notes: [],
            hybridMethods: [],
            properties: [],
            // parentBlockId: this.form.get("propertiesForm").get("parentBlockId").value,
            importParentAttributesParameters: false,
        };
        // const propertiesArray = this.form
        //   .get("propertiesForm")
        //   .get("properties") as FormArray;
        // propertiesArray.controls.forEach((item) => {
        //   const owners: IRecipient[] = item.get("owners").value
        //     ? item.get("owners").value
        //     : [];
        //   owners.forEach((owner) => {
        //     owner = RecipientUtils.removeRecipientProperties(owner);
        //   });
        // const property: IPvProperty = {
        //   sgCode: item.get("sgCode").value,
        //   address: item.get("address").value,
        //   allotment: item.get("allotment").value,
        //   zoning: item.get("zoning").value,
        //   erfNumber: item.get("erfNumber").value,
        //   farmNumber: item.get("farmNumber").value,
        //   unitNumber: item.get("unitNumber").value,
        //   subdivision: item.get("subdivision").value,
        //   erfSize: Number(item.get("erfSize").value),
        //   description: item.get("description").value,
        //   deleted: item.get("deleted").value,
        //   shape: item.get("shape").value,
        //   wkid: item.get("wkid").value,
        //   owners,
        // };
        //   application.properties.push(property);
        // });
        if (application.method.indexOf("Hybrid") > -1) {
            const methodArray = this.form
                .get("detailsForm")
                .get("valuationSplitMethodForm");
            methodArray.controls.forEach((item) => {
                const valMethod = {
                    deleted: false,
                    method: item.get("valuationSplitMethodControlName").value?.value,
                };
                application.hybridMethods.push(valMethod);
            });
        }
        const notesArray = this.form.get("noteForm").get("notes");
        notesArray.controls.forEach((item) => {
            const note = {
                note: item.get("note").value,
            };
            application.notes.push(note);
        });
        /// SETUP SALE AREA hasSalesArea
        // const salesAreaShape = this.form
        //   .get("propertiesForm")
        //   .get("salesAreaShape").value;
        // const salesArea: IPvValuationBlockSalesArea = {
        //   wkid: 102100,
        //   shape: WktConverterUtils.ConvertArcGISJsonToWkt(salesAreaShape),
        //   deleted: false,
        //   SalesAreaProperties: this.getSalesAreaProperties(),
        // };
        // application.salesArea = salesArea;
        return application;
    }
    getSalesAreaProperties() {
        // valuationBlockProperties: new FormControl(null),
        //salesAreaProperties: new FormControl(null),
        let propertiesArray = this.form
            .get("propertiesForm")
            .get("salesAreaProperties").value;
        if (!propertiesArray || propertiesArray.length == 0)
            propertiesArray = this.form
                .get("propertiesForm")
                .get("valuationBlockProperties").value;
        const sgCodes = [];
        propertiesArray.forEach((item) => {
            sgCodes.push({
                id: 0,
                sgCode: item.sgCode,
                salesAreaId: 0,
                deleted: false,
            });
        });
        return sgCodes;
    }
    initializeBuildingUseSearchOptions() {
    }
    doSearchApplicationsByCreatedByUser(userId, moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchApplicationsCreatedByUser(userId, moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appController.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    getApplicationTypes(jobId, moduleId) {
        const params = {
            moduleId
        };
        const url = `${ApiPropertyValuationValuationBlockConstants.URL}/${jobId}/${ApiPropertyValuationValuationBlockConstants.FUNCTION_APPLICATION_TYPES}`;
        return this.http.get(url, { params });
    }
    static ctorParameters = () => [
        { type: SaShortDatePipe },
        { type: ApplicationSearchService },
        { type: AttributesAndParametersService },
        { type: OdataQueryService },
        { type: RequestStatusService },
        { type: HttpClient },
        { type: AppControllerService },
        { type: Router }
    ];
};
PvStrategyService = PvStrategyService_1 = __decorate([
    Injectable({
        providedIn: "root",
    }),
    AutoUnsub()
], PvStrategyService);
export { PvStrategyService };
